import React, { useEffect } from 'react';
import { NavBar, AutoCenter, Grid } from 'antd-mobile';
import { useLocation, useNavigate } from 'react-router-dom';
import { TonConnectButton, useTonConnectUI, useTonWallet } from '@tonconnect/ui-react';
import { useT } from '../../i18n';

function Connect() {
    const navigate = useNavigate();
    const location = useLocation();
    const [tonConnectUI] = useTonConnectUI();
    const wallet = useTonWallet();
    const { t } = useT();
    const next = new URLSearchParams(location.search).get('next') || '/';

    useEffect(() => {
        if (wallet) navigate(next);
    }, [wallet, navigate, next]);

    useEffect(() => {
        const initData = window.Telegram?.WebApp?.initData || '';
        if (!initData) {
            tonConnectUI.setConnectRequestParameters(null);
            return;
        }
        let alive = true;
        tonConnectUI.setConnectRequestParameters({ state: 'loading' });
        fetch('/api/ton-proof', {
            headers: { 'x-telegram-init-data': initData },
        })
            .then((response) => (response.ok ? response.json() : null))
            .then((data) => {
                if (!alive) return;
                if (data?.payload) {
                    tonConnectUI.setConnectRequestParameters({
                        state: 'ready',
                        value: { tonProof: data.payload },
                    });
                } else {
                    tonConnectUI.setConnectRequestParameters(null);
                }
            })
            .catch(() => {
                if (alive) tonConnectUI.setConnectRequestParameters(null);
            });
        return () => {
            alive = false;
        };
    }, [tonConnectUI]);

    return (
        <>
            <NavBar backArrow={<div />}>{t('connect_title')}</NavBar>
            <div className="content">
                <Grid columns={1} gap={8}>
                    <AutoCenter>
                        <img
                            alt=""
                            src="/logo192.png"
                            style={{ width: '150px', height: '150px' }}
                        />
                    </AutoCenter>
                    <AutoCenter style={{ width: '60%', margin: '0 auto' }}>
                        {t('connect_body')}
                    </AutoCenter>
                    <AutoCenter>
                        <TonConnectButton />
                    </AutoCenter>
                </Grid>
            </div>
        </>
    );
}

export default Connect;
